import DashboardLayout from '@/views/Layout/DashboardLayout.vue';
import AuthLayout from '@/views/Pages/AuthLayout.vue';

import NotFound from '@/views/NotFoundPage.vue';

const routes = [
  {
    path: '/',
    redirect: 'dashboard',
    component: DashboardLayout,
    children: [
      {
        path: '/dashboard',
        name: 'dashboard',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "demo" */ '../views/Dashboard.vue')
      },
      {
        path: '/icons',
        name: 'icons',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Icons.vue')
      },
      {
        path: '/usuario-pos',
        name: 'usuario-pos',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Icons.vue')
      },
      {
        path: '/cajas',
        name: 'cajas',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pos/Cajas/ConfiguracionCaja.vue'),
        meta: {
          auth: true,
        },
      },
      {
        path: '/contabilidad',
        name: 'contabilidad',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/Contabilidad/Contabilidad.vue'),
        meta:{
          breadcrumb:[
              {name:'Contabilidad'}
          ]
        },
      },
      {
        path: '/proyectos',
        name: 'proyectos',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/Proyectos/Proyectos.vue'),
        meta:{
          breadcrumb:[
              {name:'Proyectos'}
          ]
        },
      },
      {
        path: '/layer',
        name: 'layer',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/Proyectos/LayerSnf.vue'),
        meta:{
          breadcrumb:[
              {name:'Layer SNF'}
          ]
        },
      },
      {
        path: '/herramienta',
        name: 'herramienta',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/Proyectos/HerramientaSnf.vue'),
        meta:{
          breadcrumb:[
              {name:'Layer Herramienta SNF'}
          ]
        },
      },            
      {
        path: '/turnos',
        name: 'turnos',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/CajaAdministrativa/Turnos.vue'),
        meta:{
          breadcrumb:[
              {name:'Arqueo de Caja', link:'/cuadre-caja'},
              {name:'Turnos de Caja'}
          ]
        },
      },
      {
        path: '/factura/desglose',
        name: 'factura/desglose',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/CajaAdministrativa/ListadoFacturaTurno.vue'),
        meta:{
          breadcrumb:[
              {name:'Arqueo de Caja', link:'/cuadre-caja'},
              {name:'Turnos de Caja', link:'/turnos'},
              {name:'Facturas por turno'}
          ]
        },
      },
      {
        path: '/listado-facturas',
        name: '/listado-facturas',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/CajaAdministrativa/ListadoFacturas.vue'),
        meta:{
          breadcrumb:[
              {name:'Arqueo de Caja', link:'/cuadre-caja'},
              {name:'Turnos de Caja', link:'/turnos'},
              {name:'Listado de Facturas'}
          ]
        },
      },
      {
        path: '/qqm',
        name: 'qqm',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/Mercadeo/Qqm.vue'),
        meta:{
          breadcrumb:[
              {name:'Quien Quiere Ser MillonaRio'}
          ]
        },
      },
      {
        path: '/wallets',
        name: '/wallets',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/Wallets/ListadoWallet.vue'),
        meta:{
          breadcrumb:[
              {name:'Contabilidad', link:'/#/contabilidad'},
              //{name:'Wallets', link:'/wallets'},
              {name:'Listado de Wallets'}
          ]
        },
      },
      {
        path: '/devoluciones',
        name: '/devoluciones',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/Contabilidad/ListadoDevoluciones.vue'),
        meta:{
          breadcrumb:[
              {name:'Contabilidad', link:'/#/contabilidad'},
              //{name:'Wallets', link:'/wallets'},
              {name:'Listado Devoluciones'}
          ]
        },
      },
      {
        path: '/profile',
        name: 'profile',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/UserProfile.vue'),
        meta: {
          auth: true,
        },
      },
      {
        path: '/usuarios',
        name: 'usuarios',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/Configuracion/Usuario.vue'),
        meta: {
          auth: true,
        },
      },
      {
        path: '/pos-usuarios',
        name: 'pos-usuarios',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pos/Usuarios/UsuariosPos.vue'),
        meta:{
          breadcrumb:[
              {name:'Configuracion Pos', link:'/pos-usuarios'},
              {name:'Usuarios'}
          ]
        },
      },
      {
        path: '/pos-acciones',
        name: 'pos-acciones',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pos/Usuarios/Acciones.vue'),
        meta:{
          breadcrumb:[
              {name:'Administración', link:'/pos-acciones'},
              {name:'Acciones'}
          ]
        },
      },
      {
        path: '/pos-modulos',
        name: 'pos-modulos',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pos/Usuarios/Modulos.vue'),
        meta:{
          breadcrumb:[
              {name:'Administración', link:'/pos-modulos'},
              {name:'Módulos'}
          ]
        },
      },
      {
        path: '/pos-roles',
        name: 'pos-roles',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pos/Usuarios/Roles.vue'),
        meta:{
          breadcrumb:[
              {name:'Administración', link:'/pos-Roles'},
              {name:'Roles'}
          ]
        },
      },
      {
        path: '/cuadre-caja',
        name: 'cuadre-caja',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/CajaAdministrativa/CuadreCaja.vue'),
        meta:{
          breadcrumb:[
              {name:'Arqueos de Caja'}
          ]
        },
      },
      {
        path: '/resumen-ventas',
        name: 'resumen-ventas',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/CajaAdministrativa/ListadoResumen.vue'),
        meta:{
          breadcrumb:[
              {name:'Resumen Ventas'}
          ]
        },
      },
      {
        path: '/resumen-turnos-arqueados',
        name: 'resumen-turnos-arqueados',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/Contabilidad/ListadoTurnosArqueados.vue'),
        meta:{
          breadcrumb:[
              {name:'Resumen Turnos'}
          ]
        },
      },
      {
        path: '/maps',
        name: 'maps',
        component: () => import(/* webpackChunkName: "demo" */ '../views/GoogleMaps.vue')
      },
      {
        path: '/tables',
        name: 'tables',
        component: () => import(/* webpackChunkName: "demo" */ '../views/RegularTables.vue')
      }
    ]
  },
  {
    path: '/',
    //redirect: 'login',
    component: AuthLayout,
    children: [
      {
        path: '/login',
        name: 'login',
        component: () => import('../views/Pages/Login.vue')
      },
      {
        path: '/register',
        name: 'register',
        component: () => import('../views/Pages/Register.vue')
      },
      { path: '*', component: NotFound }
    ]
  }
];

export default routes;
